import React, { useMemo } from 'react';

import CrowdRiff from 'components/CrowdRiff';
import { useCrowdRiffQuery } from 'hooks/useCrowdRiffQuery';
import useLiveData from 'hooks/useLiveData';

const CrowdRiffProvider = ({ children, staticData, id }) => {
    const { data } = useCrowdRiffQuery();
    const shouldLimitLiveDataByStaticIds = !staticData;
    const effectiveStaticData = React.useMemo(() => staticData || data || {}, [staticData, data]);
    const crowdRiffEdges = effectiveStaticData?.allSmartTagsCrowdRiff?.edges || [];
    const crowdRiffNodes = crowdRiffEdges.map(({ node }) => node);

    const {
        statusText: crowdRiffStatusText,
        response: crowdRiffResponse,
        visibilityChange: crowdRiffVisibilityChange,
    } = useLiveData({
        namespace: 'SmartTags',
        model: 'CrowdRiff',
        method: 'all',
        graphqlKey: 'allSmartTagsCrowdRiff',
        apiParams: {
            archived: false,
            approved: true,
            deleted: false,
            _join: 'Audience',
            ...(shouldLimitLiveDataByStaticIds && crowdRiffNodes.length > 0 ? {
                id: crowdRiffNodes.map((n) => n.id).join(','),
            } : {}),
            ...(!!id ? { id } : {}),
        },
        staticData: effectiveStaticData,
    });

    const liveCrowdRiff = crowdRiffResponse?.data[0];
    let crowdRiff = crowdRiffNodes[0];
    if (!!liveCrowdRiff && crowdRiffStatusText === 'LOADED') {
        crowdRiff = liveCrowdRiff;
    }
    if (!!liveCrowdRiff && crowdRiffVisibilityChange) crowdRiff = liveCrowdRiff;

    const datum = useMemo(() => {
        return {
            hash: crowdRiff?.hash,
            ...(crowdRiff?.title ? { title: crowdRiff.title } : {}),
            ...(crowdRiff?.hashtag ? { hashtag: crowdRiff.hashtag } : {}),
        };
    }, [crowdRiff]);

    return (
        <CrowdRiff {...datum} />
    );
};

export default CrowdRiffProvider;